import { useTheme as useVuetifyTheme } from 'vuetify'
import { onMounted } from 'vue'
import { useRPilotConfig } from './useRPilotConfig.js'

function readStoredTheme(key) {
  try {
    const stored = window.localStorage.getItem(key)
    return stored === 'light' || stored === 'dark' ? stored : null
  } catch {
    return null
  }
}

function writeStoredTheme(key, name) {
  try {
    window.localStorage.setItem(key, name)
  } catch {
    /* sandboxed iframe — non-fatal */
  }
}

function detectSystemTheme() {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

export function useTheme() {
  const theme = useVuetifyTheme()
  const cfg = useRPilotConfig()
  const storageKey = `${cfg?.namespace || 'rpilot'}.theme`

  onMounted(() => {
    theme.global.name.value = readStoredTheme(storageKey) ?? detectSystemTheme()
  })

  function toggle() {
    const next = theme.global.current.value.dark ? 'light' : 'dark'
    theme.global.name.value = next
    writeStoredTheme(storageKey, next)
  }

  return { toggle, isDark: () => theme.global.current.value.dark }
}
